import type { ListAllMembersItem } from "@albertine/types/openapi/lmt";
import React, { useState } from "react";
import { useMembersMap } from "../../../common/hooks/useMembers";
import { performOrOperatorSearch } from "../../../utils/filter.util";
import { nameWithoutTitle } from "../../../utils/members.util";
import Autocomplete from "../../Common/Autocomplete";
import { MemberAvatar } from "../../Common/Avatar";

export function AutocompleteExampleWithMembers() {
    const membersMap = useMembersMap();
    const [selectedMember, setState] = useState<ListAllMembersItem | undefined>();

    return (
        <Autocomplete<ListAllMembersItem>
            label="Member name"
            initialSelection={selectedMember}
            results={(searchTerm: string) =>
                Promise.resolve(
                    performOrOperatorSearch<ListAllMembersItem>(
                        searchTerm,
                        2,
                        [nameWithoutTitle],
                        Object.values(membersMap),
                    ),
                )
            }
            renderSingleResult={(result) => (
                <>
                    <MemberAvatar size="small" memberId={result.id} />
                    <span>{`${result.firstName} ${result.lastName}`}</span>
                </>
            )}
            onSelect={(selected) => {
                setState(selected);
                if (selected) {
                    window.alert(`${selected.firstName} ${selected.lastName}`);
                } else {
                    window.alert("Cleared the autocomplete input");
                }
            }}
        />
    );
}
